import styled, { css } from 'styled-components'
import { theme } from '../../../styles/theme'

type IProps = any & {
  isOpen: boolean;
  itemAmount?: number;
  shortMode?: boolean;
}

const containerClose = css`
  height: 93px;
  bottom: auto;

  & > nav {
    display: none;
  }
`

const containerOpen = css`
  height: auto;
  bottom: 0;
`

export const Container = styled.aside<IProps>`
  width: ${({ isOpen }) => (isOpen ? '310px' : '93px')};
  height: 100vh;
  padding: 47px 25px;
  padding-bottom: 0px;

  background: ${theme.colors.gray300};

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  overflow: hidden;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  z-index: 999;

  transition: width 300ms;

  & > nav {
    width: 100%;
    overflow-x: hidden;
    overflow-y: auto;
  }

  & > nav::-webkit-scrollbar { 
    display: none;
  }

  @media (max-width: 650px) {
    ${({ isOpen }) => (isOpen ? containerOpen : containerClose)}
  }
`

export const BurgerButton = styled.button`
  margin-bottom: 33px;
  margin-left: 9px;
  
  display: flex;
  align-items: center;
  justify-content: center;

  background-color: transparent;
  
  overflow: hidden;
`

export const Logo = styled.img<IProps>`
  padding-top: 2px;
  margin-left: 33px;

  opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
  transition: opacity 600ms;
`
